import { createFileRoute } from '@tanstack/react-router';
import { YoutubeCommentAnalyzerPage } from '../../../pages/tools/research-tools/YoutubeCommentAnalyzerPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/youtube-comment-analyzer')({
  head: () => toolHead('youtube-comment-analyzer'),
  component: YoutubeCommentAnalyzerPage,
});
